export const marinaDiscoveryCopy = {
  en: {
    heroBadge: "Marina Discovery",
    heroTitle: "Discover the world’s best marinas",
    heroIntro: "Search safe harbors, compare protection, check services, preview conditions, and plan smarter sailing stops in seconds.",
    searchPlaceholder: "Search marina, country, city, route or destination…",
    searchAria: "Search marinas by name, country, city, route, or destination",
    clearSearch: "Clear marina search",
    instantResults: "instant results",
    popular: "Popular:",
    recent: "recent",
    marina: "marina",
    city: "city",
    country: "country",
    region: "region",
    planningSnapshot: "Live Planning Snapshot",
    wind: "Wind",
    safeArrivals: "Safe arrivals",
    good: "Good",
    regions: "Regions",
    marinas: "Marinas",
    featuredStops: "Featured Stops",
    resultsLine: (visible, total) => `Showing ${visible} of ${total} marinas`,
    exploreSafeHarbors: "Explore Safe Harbors",
    noMatches: "No marinas match this search",
    noMatchesHint: "Try a broader country, region, service or boat suitability filter.",
    clearFilters: "Clear Filters",
    loadMore: "Load More Marinas",
    countryFilter: "Country",
    allCountries: "All countries",
    regionFilter: "Region",
    allRegions: "All regions",
    suitability: "Suitability",
    allVessels: "All vessels",
    weatherProtected: "Weather protected",
    catamaranFriendly: "Catamaran friendly",
    superyachtReady: "Superyacht ready",
    filters: "Filters",
    reset: "Reset",
    services: "Services",
    sort: "Sort",
    highestRated: "Highest rated",
    lowerFeesFirst: "Lower fees first",
    nameAZ: "Name A–Z",
    serviceFuel: "Fuel dock",
    serviceElectricity: "Electricity",
    serviceWater: "Water",
    serviceRepair: "Repairs",
    serviceCustoms: "Customs",
    askMarina: "Ask marina",
    save: (name) => `Save ${name}`,
    protected: "Protected",
    rating: "Rating",
    protection: "Protection",
    safeArrival: "Safe arrival",
    lightSwell: "light swell",
    openHub: "Open Hub",
    preview: "Preview",
    addToVoyage: "Add to Voyage",
    compare: "Compare",
  },
  he: {
    heroBadge: "איתור מרינות",
    heroTitle: "גלו את המרינות הטובות בעולם",
    heroIntro: "חפשו נמלי מבטחים, השוו רמת הגנה, בדקו שירותים, צפו בתנאים ותכננו עצירות שייט חכמות בתוך שניות.",
    searchPlaceholder: "חפשו מרינה, מדינה, עיר, מסלול או יעד…",
    searchAria: "חיפוש מרינות לפי שם, מדינה, עיר, מסלול או יעד",
    clearSearch: "נקה חיפוש מרינות",
    instantResults: "תוצאות מיידיות",
    popular: "פופולרי:",
    recent: "חיפוש אחרון",
    marina: "מרינה",
    city: "עיר",
    country: "מדינה",
    region: "אזור",
    planningSnapshot: "תמונת תכנון חיה",
    wind: "רוח",
    safeArrivals: "הגעה בטוחה",
    good: "טוב",
    regions: "אזורים",
    marinas: "מרינות",
    featuredStops: "עצירות מומלצות",
    resultsLine: (visible, total) => `מציג ${visible} מתוך ${total} מרינות`,
    exploreSafeHarbors: "גלו נמלי מבטחים",
    noMatches: "לא נמצאו מרינות שמתאימות לחיפוש",
    noMatchesHint: "נסו מדינה, אזור, שירות או התאמת כלי שיט רחבים יותר.",
    clearFilters: "נקה מסננים",
    loadMore: "טען עוד מרינות",
    countryFilter: "מדינה",
    allCountries: "כל המדינות",
    regionFilter: "אזור",
    allRegions: "כל האזורים",
    suitability: "התאמה",
    allVessels: "כל כלי השיט",
    weatherProtected: "מוגנת ממזג אוויר",
    catamaranFriendly: "מתאימה לקטמרנים",
    superyachtReady: "מתאימה לסופר-יאכטות",
    filters: "מסננים",
    reset: "איפוס",
    services: "שירותים",
    sort: "מיון",
    highestRated: "דירוג גבוה ביותר",
    lowerFeesFirst: "מחירים נמוכים קודם",
    nameAZ: "שם א–ת",
    serviceFuel: "רציף תדלוק",
    serviceElectricity: "חשמל",
    serviceWater: "מים",
    serviceRepair: "תיקונים",
    serviceCustoms: "מכס",
    askMarina: "בדקו מול המרינה",
    save: (name) => `שמור את ${name}`,
    protected: "מוגנת",
    rating: "דירוג",
    protection: "הגנה",
    safeArrival: "הגעה בטוחה",
    lightSwell: "ים קל",
    openHub: "פתח מרכז מידע",
    preview: "תצוגה מקדימה",
    addToVoyage: "הוסף להפלגה",
    compare: "השווה",
  },
  es: {
    heroBadge: "Descubrimiento de marinas",
    heroTitle: "Descubre las mejores marinas del mundo",
    heroIntro: "Busca puertos seguros, compara protección, revisa servicios, previsualiza condiciones y planifica escalas más inteligentes en segundos.",
    searchPlaceholder: "Buscar marina, país, ciudad, ruta o destino…",
    searchAria: "Buscar marinas por nombre, país, ciudad, ruta o destino",
    clearSearch: "Borrar búsqueda de marinas",
    instantResults: "resultados instantáneos",
    popular: "Popular:",
    recent: "reciente",
    marina: "marina",
    city: "ciudad",
    country: "país",
    region: "región",
    planningSnapshot: "Resumen de planificación en vivo",
    wind: "Viento",
    safeArrivals: "Llegadas seguras",
    good: "Bueno",
    regions: "Regiones",
    marinas: "Marinas",
    featuredStops: "Escalas destacadas",
    resultsLine: (visible, total) => `Mostrando ${visible} de ${total} marinas`,
    exploreSafeHarbors: "Explorar puertos seguros",
    noMatches: "Ninguna marina coincide con esta búsqueda",
    noMatchesHint: "Prueba con un país, región, servicio o filtro de embarcación más amplio.",
    clearFilters: "Borrar filtros",
    loadMore: "Cargar más marinas",
    countryFilter: "País",
    allCountries: "Todos los países",
    regionFilter: "Región",
    allRegions: "Todas las regiones",
    suitability: "Idoneidad",
    allVessels: "Todas las embarcaciones",
    weatherProtected: "Protegida del clima",
    catamaranFriendly: "Apta para catamaranes",
    superyachtReady: "Preparada para superyates",
    filters: "Filtros",
    reset: "Restablecer",
    services: "Servicios",
    sort: "Ordenar",
    highestRated: "Mejor valoradas",
    lowerFeesFirst: "Tarifas más bajas primero",
    nameAZ: "Nombre A–Z",
    serviceFuel: "Muelle de combustible",
    serviceElectricity: "Electricidad",
    serviceWater: "Agua",
    serviceRepair: "Reparaciones",
    serviceCustoms: "Aduana",
    askMarina: "Consultar marina",
    save: (name) => `Guardar ${name}`,
    protected: "Protegida",
    rating: "Valoración",
    protection: "Protección",
    safeArrival: "Llegada segura",
    lightSwell: "oleaje ligero",
    openHub: "Abrir centro",
    preview: "Vista previa",
    addToVoyage: "Añadir al viaje",
    compare: "Comparar",
  },
  it: {
    heroBadge: "Scoperta marine",
    heroTitle: "Scopri le migliori marine del mondo",
    heroIntro: "Cerca porti sicuri, confronta protezione, controlla servizi, anteprima condizioni e pianifica scali più intelligenti in pochi secondi.",
    searchPlaceholder: "Cerca marina, paese, città, rotta o destinazione…",
    searchAria: "Cerca marine per nome, paese, città, rotta o destinazione",
    clearSearch: "Cancella ricerca marine",
    instantResults: "risultati istantanei",
    popular: "Popolari:",
    recent: "recente",
    marina: "marina",
    city: "città",
    country: "paese",
    region: "regione",
    planningSnapshot: "Istantanea pianificazione live",
    wind: "Vento",
    safeArrivals: "Arrivi sicuri",
    good: "Buono",
    regions: "Regioni",
    marinas: "Marine",
    featuredStops: "Scali in evidenza",
    resultsLine: (visible, total) => `Mostra ${visible} di ${total} marine`,
    exploreSafeHarbors: "Esplora porti sicuri",
    noMatches: "Nessuna marina corrisponde alla ricerca",
    noMatchesHint: "Prova con paese, regione, servizio o filtro barca più ampio.",
    clearFilters: "Cancella filtri",
    loadMore: "Carica altre marine",
    countryFilter: "Paese",
    allCountries: "Tutti i paesi",
    regionFilter: "Regione",
    allRegions: "Tutte le regioni",
    suitability: "Idoneità",
    allVessels: "Tutte le barche",
    weatherProtected: "Protetta dal meteo",
    catamaranFriendly: "Adatta ai catamarani",
    superyachtReady: "Pronta per superyacht",
    filters: "Filtri",
    reset: "Reimposta",
    services: "Servizi",
    sort: "Ordina",
    highestRated: "Più valutate",
    lowerFeesFirst: "Tariffe più basse prima",
    nameAZ: "Nome A–Z",
    serviceFuel: "Rifornimento",
    serviceElectricity: "Elettricità",
    serviceWater: "Acqua",
    serviceRepair: "Riparazioni",
    serviceCustoms: "Dogana",
    askMarina: "Chiedi alla marina",
    save: (name) => `Salva ${name}`,
    protected: "Protetta",
    rating: "Valutazione",
    protection: "Protezione",
    safeArrival: "Arrivo sicuro",
    lightSwell: "onda leggera",
    openHub: "Apri hub",
    preview: "Anteprima",
    addToVoyage: "Aggiungi al viaggio",
    compare: "Confronta",
  },
  fr: {
    heroBadge: "Découverte de marinas",
    heroTitle: "Découvrez les meilleures marinas du monde",
    heroIntro: "Recherchez des ports sûrs, comparez la protection, vérifiez les services, prévisualisez les conditions et planifiez des escales plus intelligentes en quelques secondes.",
    searchPlaceholder: "Rechercher marina, pays, ville, route ou destination…",
    searchAria: "Rechercher des marinas par nom, pays, ville, route ou destination",
    clearSearch: "Effacer la recherche de marinas",
    instantResults: "résultats instantanés",
    popular: "Populaire :",
    recent: "récent",
    marina: "marina",
    city: "ville",
    country: "pays",
    region: "région",
    planningSnapshot: "Aperçu de planification en direct",
    wind: "Vent",
    safeArrivals: "Arrivées sûres",
    good: "Bon",
    regions: "Régions",
    marinas: "Marinas",
    featuredStops: "Escales en vedette",
    resultsLine: (visible, total) => `Affichage de ${visible} sur ${total} marinas`,
    exploreSafeHarbors: "Explorer les ports sûrs",
    noMatches: "Aucune marina ne correspond à cette recherche",
    noMatchesHint: "Essayez un pays, une région, un service ou un filtre de bateau plus large.",
    clearFilters: "Effacer les filtres",
    loadMore: "Charger plus de marinas",
    countryFilter: "Pays",
    allCountries: "Tous les pays",
    regionFilter: "Région",
    allRegions: "Toutes les régions",
    suitability: "Adaptation",
    allVessels: "Tous les bateaux",
    weatherProtected: "Protégée de la météo",
    catamaranFriendly: "Adaptée aux catamarans",
    superyachtReady: "Prête pour superyachts",
    filters: "Filtres",
    reset: "Réinitialiser",
    services: "Services",
    sort: "Trier",
    highestRated: "Mieux notées",
    lowerFeesFirst: "Tarifs bas d'abord",
    nameAZ: "Nom A–Z",
    serviceFuel: "Carburant",
    serviceElectricity: "Électricité",
    serviceWater: "Eau",
    serviceRepair: "Réparations",
    serviceCustoms: "Douane",
    askMarina: "Demander à la marina",
    save: (name) => `Enregistrer ${name}`,
    protected: "Protégée",
    rating: "Note",
    protection: "Protection",
    safeArrival: "Arrivée sûre",
    lightSwell: "houle légère",
    openHub: "Ouvrir le hub",
    preview: "Aperçu",
    addToVoyage: "Ajouter au voyage",
    compare: "Comparer",
  },
  de: {
    heroBadge: "Marina-Entdeckung",
    heroTitle: "Entdecken Sie die besten Marinas der Welt",
    heroIntro: "Suchen Sie sichere Häfen, vergleichen Sie Schutz, prüfen Sie Services, sehen Sie Bedingungen vorab und planen Sie intelligentere Segelstopps in Sekunden.",
    searchPlaceholder: "Marina, Land, Stadt, Route oder Ziel suchen…",
    searchAria: "Marinas nach Name, Land, Stadt, Route oder Ziel suchen",
    clearSearch: "Marina-Suche löschen",
    instantResults: "Sofortergebnisse",
    popular: "Beliebt:",
    recent: "kürzlich",
    marina: "Marina",
    city: "Stadt",
    country: "Land",
    region: "Region",
    planningSnapshot: "Live-Planungsübersicht",
    wind: "Wind",
    safeArrivals: "Sichere Ankünfte",
    good: "Gut",
    regions: "Regionen",
    marinas: "Marinas",
    featuredStops: "Empfohlene Stopps",
    resultsLine: (visible, total) => `Zeige ${visible} von ${total} Marinas`,
    exploreSafeHarbors: "Sichere Häfen entdecken",
    noMatches: "Keine Marinas passen zu dieser Suche",
    noMatchesHint: "Versuchen Sie ein breiteres Land, eine Region, einen Service oder Bootstyp.",
    clearFilters: "Filter löschen",
    loadMore: "Mehr Marinas laden",
    countryFilter: "Land",
    allCountries: "Alle Länder",
    regionFilter: "Region",
    allRegions: "Alle Regionen",
    suitability: "Eignung",
    allVessels: "Alle Boote",
    weatherProtected: "Wetterschutz",
    catamaranFriendly: "Katamaranfreundlich",
    superyachtReady: "Superyachtbereit",
    filters: "Filter",
    reset: "Zurücksetzen",
    services: "Services",
    sort: "Sortieren",
    highestRated: "Bestbewertet",
    lowerFeesFirst: "Niedrigere Gebühren zuerst",
    nameAZ: "Name A–Z",
    serviceFuel: "Tankstelle",
    serviceElectricity: "Strom",
    serviceWater: "Wasser",
    serviceRepair: "Reparaturen",
    serviceCustoms: "Zoll",
    askMarina: "Marina fragen",
    save: (name) => `${name} speichern`,
    protected: "Geschützt",
    rating: "Bewertung",
    protection: "Schutz",
    safeArrival: "Sichere Ankunft",
    lightSwell: "leichter Schwell",
    openHub: "Hub öffnen",
    preview: "Vorschau",
    addToVoyage: "Zur Reise hinzufügen",
    compare: "Vergleichen",
  },
  pt: {
    heroBadge: "Descoberta de marinas",
    heroTitle: "Descubra as melhores marinas do mundo",
    heroIntro: "Pesquise portos seguros, compare proteção, verifique serviços, veja condições e planeje paradas de navegação mais inteligentes em segundos.",
    searchPlaceholder: "Pesquisar marina, país, cidade, rota ou destino…",
    searchAria: "Pesquisar marinas por nome, país, cidade, rota ou destino",
    clearSearch: "Limpar pesquisa de marinas",
    instantResults: "resultados instantâneos",
    popular: "Popular:",
    recent: "recente",
    marina: "marina",
    city: "cidade",
    country: "país",
    region: "região",
    planningSnapshot: "Resumo de planejamento ao vivo",
    wind: "Vento",
    safeArrivals: "Chegadas seguras",
    good: "Bom",
    regions: "Regiões",
    marinas: "Marinas",
    featuredStops: "Paradas em destaque",
    resultsLine: (visible, total) => `Mostrando ${visible} de ${total} marinas`,
    exploreSafeHarbors: "Explorar portos seguros",
    noMatches: "Nenhuma marina corresponde a esta pesquisa",
    noMatchesHint: "Tente um país, região, serviço ou filtro de embarcação mais amplo.",
    clearFilters: "Limpar filtros",
    loadMore: "Carregar mais marinas",
    countryFilter: "País",
    allCountries: "Todos os países",
    regionFilter: "Região",
    allRegions: "Todas as regiões",
    suitability: "Adequação",
    allVessels: "Todas as embarcações",
    weatherProtected: "Protegida do tempo",
    catamaranFriendly: "Adequada para catamarãs",
    superyachtReady: "Pronta para superiates",
    filters: "Filtros",
    reset: "Redefinir",
    services: "Serviços",
    sort: "Ordenar",
    highestRated: "Mais bem avaliadas",
    lowerFeesFirst: "Menores taxas primeiro",
    nameAZ: "Nome A–Z",
    serviceFuel: "Abastecimento",
    serviceElectricity: "Eletricidade",
    serviceWater: "Água",
    serviceRepair: "Reparos",
    serviceCustoms: "Alfândega",
    askMarina: "Consultar marina",
    save: (name) => `Salvar ${name}`,
    protected: "Protegida",
    rating: "Avaliação",
    protection: "Proteção",
    safeArrival: "Chegada segura",
    lightSwell: "ondulação leve",
    openHub: "Abrir hub",
    preview: "Prévia",
    addToVoyage: "Adicionar à viagem",
    compare: "Comparar",
  },
  ar: {
    heroBadge: "اكتشاف المراسي",
    heroTitle: "اكتشف أفضل المراسي في العالم",
    heroIntro: "ابحث عن مرافئ آمنة، قارن الحماية، تحقق من الخدمات، عاين الظروف، وخطط لتوقفات إبحار أذكى خلال ثوانٍ.",
    searchPlaceholder: "ابحث عن مرسى أو دولة أو مدينة أو مسار أو وجهة…",
    searchAria: "البحث عن المراسي حسب الاسم أو الدولة أو المدينة أو المسار أو الوجهة",
    clearSearch: "مسح بحث المراسي",
    instantResults: "نتائج فورية",
    popular: "شائع:",
    recent: "حديث",
    marina: "مرسى",
    city: "مدينة",
    country: "دولة",
    region: "منطقة",
    planningSnapshot: "لمحة تخطيط مباشرة",
    wind: "الرياح",
    safeArrivals: "وصول آمن",
    good: "جيد",
    regions: "المناطق",
    marinas: "المراسي",
    featuredStops: "توقفات مميزة",
    resultsLine: (visible, total) => `عرض ${visible} من ${total} مرسى`,
    exploreSafeHarbors: "استكشف المرافئ الآمنة",
    noMatches: "لا توجد مراسٍ تطابق هذا البحث",
    noMatchesHint: "جرّب دولة أو منطقة أو خدمة أو فلتر قارب أوسع.",
    clearFilters: "مسح الفلاتر",
    loadMore: "تحميل المزيد من المراسي",
    countryFilter: "الدولة",
    allCountries: "كل الدول",
    regionFilter: "المنطقة",
    allRegions: "كل المناطق",
    suitability: "الملاءمة",
    allVessels: "كل القوارب",
    weatherProtected: "محمي من الطقس",
    catamaranFriendly: "مناسب للكاتاماران",
    superyachtReady: "جاهز لليخوت الفاخرة",
    filters: "الفلاتر",
    reset: "إعادة ضبط",
    services: "الخدمات",
    sort: "ترتيب",
    highestRated: "الأعلى تقييماً",
    lowerFeesFirst: "الرسوم الأقل أولاً",
    nameAZ: "الاسم أ–ي",
    serviceFuel: "وقود",
    serviceElectricity: "كهرباء",
    serviceWater: "مياه",
    serviceRepair: "إصلاحات",
    serviceCustoms: "جمارك",
    askMarina: "اسأل المرسى",
    save: (name) => `حفظ ${name}`,
    protected: "محمي",
    rating: "التقييم",
    protection: "الحماية",
    safeArrival: "وصول آمن",
    lightSwell: "موج خفيف",
    openHub: "فتح المركز",
    preview: "معاينة",
    addToVoyage: "إضافة إلى الرحلة",
    compare: "مقارنة",
  },
  el: {
    heroBadge: "Ανακάλυψη μαρινών",
    heroTitle: "Ανακαλύψτε τις καλύτερες μαρίνες του κόσμου",
    heroIntro: "Αναζητήστε ασφαλή λιμάνια, συγκρίνετε προστασία, ελέγξτε υπηρεσίες, δείτε συνθήκες και σχεδιάστε πιο έξυπνες στάσεις ιστιοπλοΐας σε δευτερόλεπτα.",
    searchPlaceholder: "Αναζήτηση μαρίνας, χώρας, πόλης, διαδρομής ή προορισμού…",
    searchAria: "Αναζήτηση μαρινών ανά όνομα, χώρα, πόλη, διαδρομή ή προορισμό",
    clearSearch: "Καθαρισμός αναζήτησης μαρινών",
    instantResults: "άμεσα αποτελέσματα",
    popular: "Δημοφιλή:",
    recent: "πρόσφατο",
    marina: "μαρίνα",
    city: "πόλη",
    country: "χώρα",
    region: "περιοχή",
    planningSnapshot: "Ζωντανή εικόνα σχεδιασμού",
    wind: "Άνεμος",
    safeArrivals: "Ασφαλείς αφίξεις",
    good: "Καλό",
    regions: "Περιοχές",
    marinas: "Μαρίνες",
    featuredStops: "Προτεινόμενες στάσεις",
    resultsLine: (visible, total) => `Εμφάνιση ${visible} από ${total} μαρίνες`,
    exploreSafeHarbors: "Εξερευνήστε ασφαλή λιμάνια",
    noMatches: "Καμία μαρίνα δεν ταιριάζει με αυτή την αναζήτηση",
    noMatchesHint: "Δοκιμάστε ευρύτερη χώρα, περιοχή, υπηρεσία ή φίλτρο σκάφους.",
    clearFilters: "Καθαρισμός φίλτρων",
    loadMore: "Φόρτωση περισσότερων μαρινών",
    countryFilter: "Χώρα",
    allCountries: "Όλες οι χώρες",
    regionFilter: "Περιοχή",
    allRegions: "Όλες οι περιοχές",
    suitability: "Καταλληλότητα",
    allVessels: "Όλα τα σκάφη",
    weatherProtected: "Προστατευμένη από καιρό",
    catamaranFriendly: "Φιλική για καταμαράν",
    superyachtReady: "Έτοιμη για superyacht",
    filters: "Φίλτρα",
    reset: "Επαναφορά",
    services: "Υπηρεσίες",
    sort: "Ταξινόμηση",
    highestRated: "Υψηλότερη βαθμολογία",
    lowerFeesFirst: "Χαμηλότερα τέλη πρώτα",
    nameAZ: "Όνομα Α–Ω",
    serviceFuel: "Καύσιμα",
    serviceElectricity: "Ρεύμα",
    serviceWater: "Νερό",
    serviceRepair: "Επισκευές",
    serviceCustoms: "Τελωνείο",
    askMarina: "Ρωτήστε τη μαρίνα",
    save: (name) => `Αποθήκευση ${name}`,
    protected: "Προστατευμένη",
    rating: "Βαθμολογία",
    protection: "Προστασία",
    safeArrival: "Ασφαλής άφιξη",
    lightSwell: "ελαφρύς κυματισμός",
    openHub: "Άνοιγμα κόμβου",
    preview: "Προεπισκόπηση",
    addToVoyage: "Προσθήκη στο ταξίδι",
    compare: "Σύγκριση",
  },
};

export function getMarinaDiscoveryCopy(lang = "en") {
  return marinaDiscoveryCopy[lang] || marinaDiscoveryCopy.en;
}